<div #beforeContainerRef class="toolbar-align-before">
  <ng-content
    select="[appToolbarItemBefore]"
  ></ng-content>
</div>

<div #centerContainerRef class="toolbar-align-center">
  <ng-content select="[appToolbarItemCenter]"></ng-content>
</div>

<div #afterContainerRef class="toolbar-align-after">
  <ng-content select="[appToolbarItemAfter]"></ng-content>
</div>
